module.exports = __webpack_public_path__ + "exo-latin-800italic.c989d9d241c710a02bba.woff";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-800italic.woff
// module id = ../../../../typeface-exo/files/exo-latin-800italic.woff
// module chunks = styles